var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1611 1425",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1600 893c0 32-25.74 58-57.5 58s-57.5-26-57.5-58",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1600 49c-39.77 0-72-32.46-72-72.5s32.23-72.5 72-72.5",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562-37.09a60 60 0 0 0 60 60.09 60 60 0 0 0 60-60.09v-67.91",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.24 1306c-74.69 0-135.24-60.21-135.24-134.5s60.55-134.5 135.24-134.5h123.76",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129 1214c-24.84 0-45-19.47-45-43.5s20.14-43.5 45-43.5h48",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1600 356v-168.32a60 60 0 0 0 -120 0v26",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673 859.54h-179.44c-45.23 0-81.89 36.47-81.89 81.46s36.66 81.46 81.89 81.46h74.06m-200.78 283.54h-10.7a57.21 57.21 0 0 1 0-114.42h127.58a84.48 84.48 0 0 0 84.43-84.53m-178.39-625.05v64.29c0 78.3 63.41 141.78 141.62 141.78h56.41a85.26 85.26 0 0 1 85.21 85.31",
    transform: "translate(4.5 112.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.5,
    cy: 399.5,
    r: 40
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.5,
    cy: 1202,
    rx: 58,
    ry: 57.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 263.5,
    r: 63
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 112.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.5 288c77.6 0 140.5-62 140.5-138.5s-62.9-138.5-140.5-138.5-140.5 62-140.5 138.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311.21 1118.46c-21.35 79.81 24.79 161.54 103.14 182.54s159.09-26.65 180.44-106.47-24.79-161.53-103.14-182.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.83 1107c-85 0-153.83-75.43-153.83-168.49a179.74 179.74 0 0 1 22.7-88.14m236.3-81.37h-104.8c-33.53 0-64.56 11.6-89.84 31.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.5 308a57.5 57.5 0 1 0 57.5 57.5v-57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346-28.5c0 42.25 34 76.5 76 76.5s76-34.25 76-76.5-34-76.5-76-76.5h-76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.5 760.58c-36.73 0-66.5-29.45-66.5-65.79s29.77-65.79 66.5-65.79 66.5 29.46 66.5 65.79v201.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1462 764c0 33.69 26.87 61 60 61s60-27.31 60-61-26.86-61-60-61h-201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m966 33.79c-35.35 0-64 28.25-64 63.11s28.65 63.1 64 63.1 64-28.25 64-63.1v-202.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914.92 1248c0-32 25.76-58 57.54-58s57.54 26 57.54 58-25.76 58-57.54 58h-91.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1089.5 456.58a57.21 57.21 0 1 1 -57.5 57.21v-213.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.5 462.71c-31.76 0-57.5 25.36-57.5 56.64s25.74 56.65 57.5 56.65 57.5-25.36 57.5-56.65v-231.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m688.7 288c0-56.88-45.37-103-101.35-103s-101.35 46.12-101.35 103 45.38 103 101.35 103h265.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1498.64 621c56 0 101.36-46.12 101.36-103s-45.37-103-101.36-103h-265.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1107 69.5c0-53.3 42.74-96.5 95.46-96.5h98.08c52.72 0 95.46 43.2 95.46 96.5 0 53.3-42.74 96.5-95.46 96.5h-98.08c-52.72 0-95.46-43.2-95.46-96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.5 765a59.45 59.45 0 0 1 -59.5-59.4v-169.2a59.45 59.45 0 0 1 59.5-59.4 59.45 59.45 0 0 1 59.5 59.4v169.2a59.45 59.45 0 0 1 -59.5 59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828 689.5v-89.33a46.34 46.34 0 0 1 46.5-46.17 46.34 46.34 0 0 1 46.5 46.17v178.66a46.34 46.34 0 0 1 -46.5 46.17 46.34 46.34 0 0 1 -46.5-46.17v-21.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914 211.93v7.79a80.39 80.39 0 0 1 -80.5 80.28 80.39 80.39 0 0 1 -80.5-80.28v-244.44a80.39 80.39 0 0 1 80.5-80.28 80.39 80.39 0 0 1 80.5 80.28v2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.75 846h-4.81a62 62 0 0 0 -61.94 62 62 62 0 0 0 61.94 62h143.12a62 62 0 0 0 61.94-62 62 62 0 0 0 -61.94-62h-4.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 554v231.64c0 69.23 56.64 125.36 126.5 125.36s126.5-56.13 126.5-125.36v-54.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 946h207.8c79.09 0 143.2 64.47 143.2 144s-64.11 144-143.2 144h-62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m586 595h-49.19a60 60 0 0 1 0-120h98.38a59.9 59.9 0 0 1 59.81 60v5.33a54.59 54.59 0 0 1 -54.5 54.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1089.5 366h56.18c37.73 0 68.32-28.88 68.32-64.5s-30.59-64.5-68.32-64.5h-112.36c-37.73 0-68.32 28.88-68.32 64.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675 97h-134.68c-85.23 0-154.32 69.4-154.32 155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1449.5 1100.84c31.76 0 57.5 25.56 57.5 57.08s-25.74 57.08-57.5 57.08-57.5-25.56-57.5-57.08v-371.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019 1138c0-58.54 46.85-106 104.63-106h184.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m747 475h98.37c66.07 0 119.63-53.73 119.63-120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1321 788v53.76a98.27 98.27 0 0 1 -98.29 98.24h-76.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1507 520h-84c-60.75 0-110 49.7-110 111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 1306v-91.12c0-52.46 41-96.41 96-107.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.5 220v184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.5 643v152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m934.5 1056v62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1233 481v142.33a40.7 40.7 0 0 1 -40.86 40.54 40.71 40.71 0 0 0 -40.87 40.55v8.41a40.72 40.72 0 0 0 40.87 40.55 40.71 40.71 0 0 1 40.86 40.55v9.31a50.06 50.06 0 0 1 -50.25 49.87h-64.17m-164.58 132.89h26.78a100.12 100.12 0 0 0 100.22-100.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1481 283.92v20.28a51.87 51.87 0 0 1 -51.94 51.8 51.88 51.88 0 0 1 -52-51.8v-16.8a51.47 51.47 0 0 0 -51.54-51.4 51.48 51.48 0 0 0 -51.52 51.4v20.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1089 1180a73 73 0 0 1 73-73 73 73 0 0 1 73 73v53a73 73 0 0 1 -73 73 73 73 0 0 1 -73-73z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP7);
export default __webpack_public_path__ + "static/media/p7.a18c6e7fcca750f345c4c43b66b521ca.svg";
export { ForwardRef as ReactComponent };